import { Component, OnInit, ViewChild } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;

@Component({
  selector: 'app-a2-general-detail',
  templateUrl: './a2-general-detail.component.html',
  styleUrls: ['./a2-general-detail.component.scss']
})
export class A2GeneralDetailComponent extends GridBaseCase {
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName: string = null;
  roles: string = null;
  writeOff:any=60;//会员在60个自然日内产生购买才能核销
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public actionSheet: ActionSheetController
  ) {
    super();
    const that = this;
    that.writeOff = app.writeOff || 60;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.com.GetAccount.Roles.forEach(role => {
      that.roles = role.Code;
    });
    let tbcode = that.activaRouter.snapshot.paramMap.get('tbcode');
    console.log(tbcode,",,,,,,,,,,,,,,,,,,,,,,,,,")
  }
  LoadData() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    console.log(that.activaRouter.snapshot.paramMap);
    console.log(PageName,"拿过来的名字")
    let tbcode:any;
    if(PageName == "PGManageDetail"){
       tbcode = that.activaRouter.snapshot.paramMap.get('id').split("&")[1];
    }
    
    console.log(tbcode,",,,,,,,,,,,,,,,,,,,,,,,,,")
    if (id) {
      id = id.split("&")[0];
    }
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (PageName == "DailyBillInquiryDetail") {
      body.RequestBody = JSON.stringify({ "orderid": id });
    } else {
      let arrjond={};
      arrjond["a_ID"] = id;
      if(tbcode){
        arrjond["tb_Code"] = tbcode;
      }
      body.RequestBody = JSON.stringify(arrjond);
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.dataArrayList = [];
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        console.log(data.Status.Datas,"数据库");
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          let arrType=[];
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              // debugger;
              if(PageName=="ReturnGoodsDetail"){//消费者退货
                if(element.bindingField=="shortname" && item[element.field]){
                  objfield["pname"] = { "value": item[element.field], "text": element.text };
                 }else if(element.bindingField=="pname"){
                   objfield["pname"] = { "value": item[element.field], "text": element.text };
                 }else{
                  objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
                 }
              }else{
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
              console.log(objfield,"数据%%%%%%%%%%%%%%");
              console.log(JSON.stringify(objfield).length,"数据%%%%%%%%%%%%%%");
              // console.log(stringify.parseInt(objfield).length);
              if(objfield[element.bindingField]){
                if (objfield[element.bindingField].value && element.formatter && element.formatter == "Date") {
                  objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g, "/");
                }
                /**
               * 处理字段类型为图片的数据
               */
              if (objfield[element.bindingField].value && element.formatter && element.formatter == "Img") {
                let _imgArr: Array<any> = new Array<any>();
                objfield[element.bindingField].value.split(",").forEach(url => {
                  _imgArr.push((app.FileUoloadUrl + url).replace(app.ImagePlaceholder, app.SmallImageType));
                })
                objfield[element.bindingField].value = _imgArr;
              }
              if(element.bindingField == 'deadline' && objfield[element.bindingField]?objfield[element.bindingField].value:false){
                let _time = objfield[element.bindingField].value.replace(/-/g,"/");
                
                let _date = new Date(_time).getTime() + parseInt(that.writeOff) * 24 * 60 * 60 * 1000;
                let _newDate = new Date(_date);
                objfield[element.bindingField].value = _newDate;
              }
              }
              
            
            }
            if(objfield["name"] && objfield["name"].value){
              objfield["name"].value=that.com.FormatName(objfield["name"].value);
            }
            if(objfield["phone"] && objfield["phone"].value){
              objfield["phone"].value=that.com.PhoneNum(objfield["phone"].value);
            }
            that.com.CustomerTag(element,objfield,arrType);//获取所有标签
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);

        });
        // console.log(that.dataArrayList);
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  unBindStore() {
    const that = this;
    let id = null;
    if (that.dataArrayList.length > 0) {
      id = this.dataArrayList[0]["sid"]["value"];
    }
    localStorage.setItem("PgUnBindStroeId", id);
    that.com.setHistoryUrl();
    // that.router.navigate(["/tabs/contact/PGUnBindStore/add/" + that.com.getNowDatetime]);
    that.com.Go("/tabs/contact/PGUnBindStore/add/" + that.com.getNowDatetime);
  }

  async EditImg(imgArr, i) {
    const that = this;
    const pageType = that.activaRouter.snapshot.paramMap.get('type');
    if(pageType=="view"){
      that.imgPreview(imgArr, i);
      return;
    }
    const actionSheet = await this.actionSheet.create({
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          console.log('预览');
          that.imgPreview(imgArr, i);
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }
  imgPreview(imgArr, i) {
    let that = this;
    let url = [];
    if (imgArr && imgArr.length > 0) {
      imgArr.forEach(item => {
        let u = null;
        if(item.indexOf("http") > -1){
          u = item.trim().replace(app.SmallImageType, app.BigImageType);
        }else{
          u = item.trim().replace(app.SmallImageType, app.BigImageType);
        }
        url.push(u);
      });
      let ImgPreview = {
        imgUrl: url,
        index: i
      }
      that.com.setHistoryUrl();
      that.com.Go("/tabs/contact/ImgPreview/" + that.com.getNowDatetime,{ ImgPreview: JSON.stringify(ImgPreview)})
      // that.router.navigate(["/tabs/contact/ImgPreview/" + that.com.getNowDatetime], {
      //   queryParams: {
      //     ImgPreview: JSON.stringify(ImgPreview)
      //   }
      // });
    }


  }
}
